// ======================================================================
// File Name       : RegisterMessageContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import { Form, Button, Col } from 'react-bootstrap';
import Header from '../../components/Header';
import RegisterMessageThreadInfo from '../../components/messageThread/RegisterMessageThreadInfo';
import RegisterMessageUserList from '../../components/messageThread/RegisterMessageUserList';
import RegisterUserDialogContainer from './RegisterUserDialogContainer';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import { MODE } from '../../constants/index';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../../constants/MessageThreadContants';
import { SENT_MESSAGE_LIST } from '../../constants/PathConstants';
import * as ModalIds from '../../constants/ModalIds';
import * as ModalAction from '../../actions/ModalAction';
import ModalConductor from '../../components/modal/ModalConductor';
import { isSuperUser } from '../../utils/index';
import * as userActions from '../../actions/UserAction';
import * as GroupAction from '../../actions/GroupAction';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class RegisterMessageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.registerMessageThread = this.registerMessageThread.bind(this);
    this.createParam = this.createParam.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.removeUserFromList = this.removeUserFromList.bind(this);
    this.radioChange = this.radioChange.bind(this);
    this.removeAllUserFromList = this.removeAllUserFromList.bind(this);
  }

  componentWillMount() {
    const { authedUser, dispatch, user } = this.props;
    dispatch(MessageThreadAction.resetEdittingUsers());
    dispatch(GroupAction.fetchGroupStructure());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(MessageThreadAction.resetEdittingUsers());
  }

  registerMessageThread() {
    this.props.dispatch(ModalAction.openModal(ModalIds.MSG_REGISTER_CONFIRM_DIALOG));
  }

  createParam(formValues) {
    const param = {};
    param.editType = MODE.NEW_MODE;
    const messageInfo = {};
    messageInfo.messageType = MESSAGE_TYPE.ROUTE;
    messageInfo.messageTitle = formValues.messageTitle || null;
    messageInfo.messageContent = formValues.messageContent;
    param.messageInfo = messageInfo;
    formValues.attachmentFile &&
      formValues.attachmentFile.length &&
      (param.attachmentFile = formValues.attachmentFile[0]);
    formValues.edittingUserList && (param.edittingUserList = formValues.edittingUserList);
    return param;
  }

  hideModal() {
    this.props.dispatch(ModalAction.hideModal());
  }

  radioChange(event, newValue, previousValue) {
    const { dispatch } = this.props;
    if (newValue && !previousValue) {
      dispatch(change('registerMessageThreadForm', 'edittingUserList', {}));
      dispatch(MessageThreadAction.resetEdittingUsers());
    }
  }

  showModal() {
    this.props.dispatch(ModalAction.openModal(ModalIds.ADD_USER_TO_MSG));
  }

  removeUserFromList(userSecernId) {
    this.props.dispatch(MessageThreadAction.removeUserFromList(userSecernId));
  }

  removeAllUserFromList() {
    const { dispatch } = this.props;
    dispatch(MessageThreadAction.removeAllUserFromList());
  }

  render() {
    const { formValues, edittingUsers } = this.props;
    let fileName = '';
    let fileSize = 0;
    if (formValues && formValues.attachmentFile && formValues.attachmentFile.length) {
      fileName = formValues.attachmentFile[0].name;
      fileSize = formValues.attachmentFile[0].size;
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SENT_MESSAGE_LIST}
          text="メッセージスレッド一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="メッセージスレッドの新規作成" />
        <h3>登録する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.registerMessageThread();
          }}
          className='form-horizontal'
        >
          <RegisterMessageThreadInfo
            fileName={fileName}
            fileSize={fileSize}
            radioChange={this.radioChange}
          />
          <RegisterMessageUserList
            showModal={this.showModal}
            edittingUsers={edittingUsers}
            removeUserFromList={this.removeUserFromList}
            formValues={formValues}
            removeAllUserFromList={this.removeAllUserFromList}
          />
          <Form.Group className="margin-top-20 text-center">
            <Button
              variant="primary"
              className="btn-96"
              type="submit"
              onClick={this.props.handleSubmit(this.registerMessageThread)}
            >
              OK
            </Button>
          </Form.Group>
        </Form>
        <ModalConductor history={this.props.history} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { registerMessageThreadForm } = state.form;
  const { authedUser } = state.authed;
  const { user } = state;
  let initial = {};
  if (registerMessageThreadForm) {
    initial = registerMessageThreadForm.initial;
    if (registerMessageThreadForm.values) {
      initial = registerMessageThreadForm.values;
    }
  }
  const { edittingUsers } = state.messageThread;
  const edittingUserList = {};
  if (edittingUsers && edittingUsers.allSecernIds) {
    const length = edittingUsers.allSecernIds.length;
    for (let i = 0; i < length; i++) {
      const userSecernId = edittingUsers.allSecernIds[i];
      edittingUserList[userSecernId] = true;
    }
  }
  const initialValues = {
    ...initial,
    ...{ edittingUserList },
  };
  return {
    registerMessageThreadForm,
    edittingUsers,
    initialValues,
    invalid: isInvalid('registerMessageThreadForm')(state),
    formValues: getFormValues('registerMessageThreadForm')(state),
    authedUser,
    user,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'registerMessageThreadForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(RegisterMessageContainer),
);
